import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  static values = { active: Boolean }

  connect() {
    if (this.activeValue) this.timer = setTimeout(() => visit(window.location.href, { action: "replace" }), 5000)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
